import React, { useEffect, useState } from "react"
import { Button, Form, Input, Col, Row, Checkbox, Table, message, Popconfirm } from "antd"
import { getModuleList, moduleInsert, moduleEdit } from "@/service/setMealService"

const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    // console.log(dataIndex)
    const inputNode = inputType === "checkbox" ? <Checkbox defaultChecked={record.selectBoxType} /> : <Input />
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={dataIndex === "modelName" ? [{ required: true, message: `请输入${title}!` }] : []}
                    valuePropName={dataIndex === "selectBoxType" ? "checked" : "value"}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    )
}
export default (props) => {
    const { modeKey, dispatch } = props
    const [form] = Form.useForm()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        let data = {
            pageSize: 1000,
            pageNum: 1,
            searchItem: {},
            orders: [
                {
                    column: "modelSort",
                    // "rule": "DESC"
                    rule: "ASC",
                },
            ],
        }
        getModuleList(data)
            .then((res) => {
                // if (res && res.retCode === 200) {
                    setData(res.retData.list)
                // } else {
                //     message.warning(res.retMsg)
                // }
            })
            .catch((err) => message.error(err.retMsg))
    }

    //表单提交
    const onSubmit = () => {
        form.validateFields().then((values) => {
            moduleInsert({
                ...values,
                selectBoxType: values.selectBoxType ? "radio" : "checkbox",
            })
                .then((res) => {
                    // if (res && res.retCode === 200) {
                        loadData()
                        form.resetFields()
                        message.success("添加成功")
                    // } else {
                    //     message.warning(res.retMsg)
                    // }
                })
                // .catch((err) => message.error(err.retMsg))
        })
    }

    const formItemLayout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    }
    //取消
    const handleCancel = () => {
        dispatch({
            type: "removeTabs",
            targetKey: modeKey,
            activeMenu: "setMealManage",
        })
    }

    //编辑table 行
    const [editForm] = Form.useForm()
    const [editingKey, setEditingKey] = useState("")
    const isEditing = (record) => record.id === editingKey

    //编辑当前行
    const edit = (record) => {
        editForm.setFieldsValue({
            modelName: "",
            modelExplain: "",
            modelSort: "",
            ...record,
            selectBoxType: record.selectBoxType === "radio" ? true : false,
        })
        setEditingKey(record.id)
    }

    const save = async (id) => {
        try {
            const row = await editForm.validateFields()
            const newData = [...data]
            const index = newData.findIndex((item) => id === item.id)
            if (index > -1) {
                // const item = newData[index];
                // newData.splice(index, 1, { ...item, ...row });
                // console.log(newData);
                moduleEdit({
                    ...row,
                    id,
                    selectBoxType: row.selectBoxType ? "radio" : "checkbox",
                })
                    .then((res) => {
                        // if (res && res.retCode === 200) {
                            // setData(newData);
                            loadData()
                            setEditingKey("")
                            message.success("修改成功")
                        // } else {
                        //     message.warning(res.retMsg)
                        // }
                    })
                    .catch((err) => message.error(err.retMsg))
            } else {
                // newData.push(row);
                // setData(newData);
                // setEditingKey('');
            }
        } catch (errInfo) {
            console.log("Validate Failed:", errInfo)
        }
    }

    const columns = [
        {
            title: "模块名称",
            align: "center",
            width: 300,
            dataIndex: "modelName",
            editable: true,
        },
        {
            title: "模块说明",
            // width: 500,
            align: "center",
            dataIndex: "modelExplain",
            editable: true,
        },
        {
            title: "模块排序",
            align: "center",
            width: 150,
            dataIndex: "modelSort",
            editable: true,
        },
        {
            title: "是否单选",
            align: "center",
            width: 150,
            dataIndex: "selectBoxType",
            editable: true,
            render: (text) => (text === "radio" ? "是" : "否"),
        },
        {
            title: "操作",
            width: 200,
            align: "center",
            render: (_, record) => {
                const editable = isEditing(record)
                return editable ? (
                    <>
                        <Button shape="round" className="yc-public-but" onClick={() => save(record.id)}>
                            保存
                        </Button>
                        <Popconfirm okText="确认" cancelText="关闭" title="取消将恢复编辑前的值！！" onConfirm={() => setEditingKey("")}>
                            <Button shape="round" className="yc-public-but">
                                取消
                            </Button>
                        </Popconfirm>
                    </>
                ) : (
                    <Button shape="round" className="yc-public-but" disabled={editingKey !== ""} onClick={() => edit(record)}>
                        编辑
                    </Button>
                )
            },
        },
    ]
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === "selectBoxType" ? "checkbox" : "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        }
    })
    return (
        <>
            <div className="toolbar">
                <span className="modules-name">维修套餐管理</span>
            </div>
            <div className="list-container">
                <div className="list-header">
                    <div className="list-name">
                        <span>模块详情</span>
                    </div>
                    <div className="list-but">
                        <Button shape="round" className="but-left" onClick={handleCancel}>
                            返回
                        </Button>
                        <Button shape="round" className="but-left" onClick={onSubmit}>
                            添加
                        </Button>
                    </div>
                </div>
                <div className="form-details-warp">
                    <Form form={form} {...formItemLayout}>
                        <Row>
                            <Col span={6} xxl={4}>
                                <Form.Item
                                    label="模块名称"
                                    name="modelName"
                                    rules={[
                                        {
                                            required: true,
                                            message: "该项为必填",
                                        },
                                    ]}
                                >
                                    <Input placeholder="模块名称" />
                                </Form.Item>
                            </Col>
                            <Col span={6} xxl={4}>
                                <Form.Item
                                    label="模块排序"
                                    name="modelSort"
                                    rules={[
                                        {
                                            required: false,
                                            message: "该项为必填",
                                        },
                                        {
                                            pattern: /^\d+$/,
                                            message: "请填写整数",
                                        },
                                    ]}
                                >
                                    <Input placeholder="模块排序" />
                                </Form.Item>
                            </Col>
                            <Col span={12} xxl={8}>
                                <Form.Item label="模块说明" name="modelExplain" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                                    <Input placeholder="模块说明" />
                                </Form.Item>
                            </Col>
                            <Col span={6} xxl={4}>
                                <Form.Item name="selectBoxType" label="是否单选" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                            </Col>
                            {/* <Col span={6} xxl={4}>
                                    <Button type="primary" onClick={onSubmit}>添加</Button>
                                </Col> */}
                        </Row>
                    </Form>
                </div>
            </div>
            <div className="list-container">
                <div className="list-header">
                    <div className="list-name">
                        <span>模块列表</span>
                    </div>
                </div>
                <Form form={editForm} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        size="small"
                        scroll={{ y: 500 }}
                        rowKey={(record) => record.id}
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={false}
                    />
                </Form>
            </div>
        </>
    )
}
